import type { IInfoActionCard } from "@app/dashboard/types/innerLayout/info-action-card";
import styles from "./info-action-card.module.scss";

export const InfoActionCard = ({
  width = '22rem',
  size = 'lg',
  color = 'gray',
  icon,
  title,
  desc,
  onClickHandler
}: IInfoActionCard) => {
  return (
    <div
      className={styles["info-action-card"]}
      data-info-action-card-color={color}
      data-info-action-card-size={size}
      style={{ width }}
      onClick={onClickHandler}
    >
      {
        icon &&
        <div className={styles["info-action-card__icon"]}>
          {icon}
        </div>
      }

      <div className={styles["info-action-card__text-box"]}>

        {
          title &&
          <div className={styles["info-action-card__text-box__title"]}>
            {title}
          </div>
        }
        {
          desc &&
          <div className={styles["info-action-card__text-box__desc"]}>
            {desc}
          </div>
        }
      </div>
    </div>
  )
}
